import langs from '../../content/languages'

export default (langKey, path) => {
  const prefix = langKey === langs.defaultLangKey ? '' : '/' + langKey
  const suffix = path.charAt(0) === '/' ? path : ('/' + path)
  return prefix + suffix
}
